import React, { Component, useRef } from 'react';
import { connect } from 'react-redux';
import { FormControl, Checkbox, Radio, DropdownButton, MenuItem } from 'react-bootstrap';
import './Photos.css';
import LazyLoad from 'react-lazy-load';
import StackGrid from 'react-stack-grid';
import Popup from "reactjs-popup";
import { API_URL, API_V2_URL, config } from '../../util/Constants';
import axios from 'axios';
import { submitImages, updateVBPInner, webhookRegister } from '../../actions/PhotowallActions';
import { trackClick } from "../../actions/TrackingActions";
import MarketingButtons from './MarketingButtons';
// import { uploadFile } from 'react-s3';
import { Trans, withTranslation } from 'react-i18next';
import { setCustomInputStyling, randomizeArray, showEmbedFooter, isValidJSON, returnValueIfNotEmpty } from '../../util/helpers/Helpers';
// import IntlTelInput from 'react-intl-tel-input';
// import 'react-intl-tel-input/dist/main.css';
import moment from 'moment';
import { Cookies } from 'react-cookie';
import $ from 'jquery';
// import IntlTelInput from "intl-tel-input/reactWithUtils";
// import "intl-tel-input/styles";

import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  PinterestIcon,
  LinkedinIcon,
  PocketIcon,
  RedditIcon,
  TumblrIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TumblrShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton
} from "react-share";
import { FaSms, FaBuffer, FaWordpress, FaFlipboard, FaSkype } from "react-icons/fa";
import { IoMdArrowDropleft, IoMdArrowDropright } from 'react-icons/io';
import CustomShare from '../components/custom-share';
import { FACEBOOK_APP_ID } from '../../util/Constants';


class Photos extends Component {
  constructor(props) {
    super(props);

    this.socialShareRef = React.createRef();

    this.matchReseesState = {
      source: 19172,
      target: 19347
    };

    this.matchReseesStateAnswers = {
      62498: 63045,
      62499: 63046,
      62500: 63047,
      62501: 63048,
      62502: 63049,
      62503: 63050,
      62504: 63051,
      62505: 63052
    }

    let omnihubData = {}
    const syncOmnihub = (event) => {
      console.log('input-data', event);
      if (event && event.data && isValidJSON(event.data)) {
        omnihubData = JSON.parse(event.data);
        console.log('input-data-1', omnihubData);
        let optinState = this.state.fields;
        let state = {
          ...this.state,
          fields: {
            ...optinState,
            first_name: returnValueIfNotEmpty(omnihubData.firstname),
            last_name: returnValueIfNotEmpty(omnihubData.lastname),
            email: returnValueIfNotEmpty(omnihubData.email),
            address: returnValueIfNotEmpty(omnihubData.address),
            postcode: returnValueIfNotEmpty(omnihubData.postcode),
            state: returnValueIfNotEmpty(omnihubData.state),
            date_of_birth: returnValueIfNotEmpty(omnihubData.dob)
          }
        };
        // if (omnihubData['other']) {
        //   let dropdown = omnihubData['other'].find(oo => oo.id == this.matchReseesState['source']);
        //   console.log('other-optin', dropdown);
        //   let dropdownValue = '';
        //   if (dropdown && dropdown['values'] && dropdown['values'][0]) {
        //     dropdownValue = dropdown['values'][0];
        //     console.log('other-optin-val', dropdownValue);
        //     state.others = {
        //         [this.matchReseesState['target']]: {
        //           selectedValues: [this.matchReseesStateAnswers[dropdownValue]]
        //         }
        //     };
        //   }
        // }
        this.setState(state);
      }
    };
    console.log('msg-new');
    window.addEventListener('message', syncOmnihub);

    const { t } = this.props;
    this.state = {
      fields: {},
      errors: {},
      charLength: '',
      charLengthCustom: 'Characters Left: 2000/2000',
      charLengthCustomComm: [],
      hashData: {},
      file: null,
      submitLoad: true,
      submitSpin: false,
      successMsg: '',
      responseError: '',
      others: [],
      fileUpload: {},
      filterImageState: 0,
      customFilterImageState: 0,
      filteredImagesList: [],
      selectedFilters: [],
      open: false,
      assetTypeId: 0,
      popupImageDescription: '',
      popupAssetUrl: null,
      loader: false,
      loaderText: '',
      hideAgeRestrictionPopup: false,
      showAgeRestrictionPopupErr: false
    };

    this.preferredCountries = ['au', 'gb', 'us', 'br', 'ca', 'cn', 'de', 'in', 'id', 'my', 'nl', 'nz', 'pt', 'sg', 'es', 'th', 'vn', 'kr'];
    this.shapesList = {
      1: '',
      2: 'no-border-radius',
      3: 'no-border-radius dyn-skew',
      4: 'dyn-circle',
      5: 'no-border-radius dyn-shield',
    };
    this.defaultShape = 1;
    this.classRadius = '';

    this.handleChange = this.handleChange.bind(this);
    this.handleOptinChange = this.handleOptinChange.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.submitUploadForm = this.submitUploadForm.bind(this);
    this.handleClickOptinOtherOptionSingle = this.handleClickOptinOtherOptionSingle.bind(this);
    this.handleSelectOptinOtherOptionSingle = this.handleSelectOptinOtherOptionSingle.bind(this);
    this.handleSelectOptinOtherOption = this.handleSelectOptinOtherOption.bind(this);
    this.handleChangeOptinOther = this.handleChangeOptinOther.bind(this);
    this.handleChangeOptinOtherComm = this.handleChangeOptinOtherComm.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateGrid = this.updateGrid.bind(this);
    this.showLoader = this.showLoader.bind(this);
    this.handleChangeShare = this.handleChangeShare.bind(this);
    this.handleCustomDescriptionChange = this.handleCustomDescriptionChange.bind(this);
    this.setAgeRestrictionAcceptance = this.setAgeRestrictionAcceptance.bind(this);

    this.intlTelInputPhoneEle = React.createRef();
    this.intlTelInputPhoneInst = null;
  }

  setAgeRestrictionAcceptance = () => {
    const cookies = new Cookies();
    cookies.set('age-restriction-' + this.props.comp.id, true);
    this.setState({
      hideAgeRestrictionPopup: true
    });
  }

  showAgeRestrictionPopupError = () => {
    this.setState({
      showAgeRestrictionPopupErr: true
    });
  }


  openModal(e, id) {
    e.preventDefault();
    if (this.props.comp && this.props.comp.imagesList
      && this.props.comp.imagesList.length > 0) {
      let assetUrl = null;
      this.props.comp.imagesList.forEach(image => {
        if (image.id === id) {
          assetUrl = this.getAssetLoaderUrl(image);
          this.setState({ assetTypeId: image.assetTypeId });
          this.setState({ popupImageDescription: image.image_description });
        }
      });
      this.setState({ popupAssetUrl: assetUrl });
      this.setState({ open: true });
    }
  }

  closeModal() {
    this.setState({ open: false });
    this.setState({ assetTypeId: 0 });
    this.setState({ popupAssetUrl: null });
  }

  modalCustomStyling(assetTypeId) {
    let styleSet = { width: 'auto', padding: '0px', background: 'transparent', border: '0px' };
    if (assetTypeId === 4) {
      styleSet.width = '90%';
      styleSet.height = '90%';
      return styleSet;
    }
    else if (assetTypeId > 0) {
      return styleSet;
    }
    return {};
  }

  renderAssetInPopup(assetTypeId) {
    switch (assetTypeId) {
      case 1:
        return <img className="image-viewer" src={this.state.popupAssetUrl} />;
      case 2:
        return <audio className="audio-playback" controls>
          <source src={this.state.popupAssetUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>;
      case 3:
        return <video className="video-playback" controls>
          <source src={this.state.popupAssetUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>;
      case 4:
        // this.setState({ open: false });
        // window.open(this.state.popupAssetUrl);
        return <iframe className="pdf-viewer" src={this.state.popupAssetUrl}></iframe>;
        break;
      default:
        return <div>{this.state.popupImageDescription}</div>;
    }
  }

  showLoader(value, text) {
    this.setState({ loader: value });
    if (value) {
      this.setState({ loaderText: text });
    }
    else {
      this.setState({ loaderText: '' });
    }
  }

  updateGrid() {
    console.log('loaded layout');
    if (this.grid) {
      this.grid.updateLayout();
    }
  }

  handleChangeFile(e) {
    const file = e.target.files[0];
    if (this.validatePhoto(file)) {
      const { name, type, size } = file;
      // const { fields: { competation_id } } = this.state;
      const competation_id = this.props.comp.id;
      const lastDot = name.lastIndexOf('.');
      const imageExtension = name.substring(lastDot + 1);
      const currentTime = new Date().getTime();
      const imageName = currentTime + '.' + imageExtension;
      const data = {
        competationID: competation_id,
        imageName: imageName,
        fileType: type
      };
      axios
        .post(`${API_V2_URL}/getPhotowallSignature`, data)
        .then((response) => {
          const url = response.data.urls[0];
          let fields = this.state.fields;
          fields['imageName'] = response.data.fileName;
          fields['filename'] = response.data.fileName;
          fields['filesize'] = size;
          fields['filetype'] = type;
          fields['competation_id'] = this.props.comp.id;
          let fileUpload = {};
          fileUpload['url'] = url;
          fileUpload['file'] = file;
          fileUpload['type'] = type;
          this.setState({
            fields
          });
          this.setState({
            fileUpload
          })
          // axios
          //   .put(url, file, {
          //     headers: {
          //       'Content-Type': type
          //     }
          //   });
        });
    }
  }

  handleChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    if (e.target.type === 'checkbox' && e.target.name === 'terms_conditions') {
      // this.setState({ file: e.target.files[0] });
      // const lastDot = e.target.files[0].name.lastIndexOf('.');
      // const ext = e.target.files[0].name.substring(lastDot + 1);

      // fields['filename'] = e.target.files[0].name;
      // fields['filesize'] = e.target.files[0].size;
      // fields['filetype'] = e.target.files[0].type;
      // fields['image_extension'] = ext;
      fields['terms_conditions'] = e.target.checked ? '1' : '0';
    }
    if (e.target.type === 'checkbox' && e.target.name === 'confirm_adult') {
      fields['confirm_adult'] = e.target.checked ? '1' : '0';
    }
    this.setState({
      fields
    });
  }

  handleMobileNumber = (event) => {
    let fields = this.state.fields;
    fields['phone'] = event;
    console.log("phone-set", fields);
    this.setState({
      fields
    });
  }

  handleOptinChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    if (e.target.type === 'checkbox') {
      fields['marketing'] = e.target.checked ? '1' : '0';
    }
    this.setState({
      fields
    });
  }

  handleCategoryChange(e) {
    let fields = this.state.fields;
    let categoriesList = document.getElementsByName('category');
    let categorySelected = [...categoriesList].find(c => c.checked);
    fields[e.target.name] = categorySelected;
    this.setState({
      fields
    });
  }

  handleSelectOptinOtherOptionSingle = (idOptinOther, e) => {
    const optin = {
      ...this.state
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
      optin.others[idOptinOther].selectedValues = [];
    }
    optin.others[idOptinOther].selectedValues = [e.target.value];
    this.setState({ optin });
  }

  handleClickOptinOtherOptionSingle = (idOptinOther, ooo, e) => {
    const optin = {
      ...this.state
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
      optin.others[idOptinOther].selectedValues = [];
    }
    optin.others[idOptinOther].selectedValues = [ooo.id];
    this.setState({ optin });
  }

  handleImageUploadClick = (e) => {
    this.imageUploadElement.click();
  }

  handleSelectOptinOtherOption = (idOptinOther, ooo, e) => {
    const optin = {
      ...this.state
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
      optin.others[idOptinOther].selectedValues = [];
    }
    if (e.target.checked) {
      optin.others[idOptinOther].selectedValues.push(ooo.id);
    } else {
      optin.others[idOptinOther].selectedValues = optin.others[idOptinOther]
        .selectedValues.filter(o2 => o2 !== ooo.id);
    }
    this.setState({ optin });
  }

  handleChangeOptinOther = (idOptinOther, e) => {
    const optin = {
      ...this.state
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
    }
    optin.others[idOptinOther].value = e.target.value;
    this.setState({ optin });
  }

  handleChangeOptinOtherComm = (idOptinOther, e) => {
    const { t } = this.props;
    const optin = {
      ...this.state
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
    }
    optin.others[idOptinOther].value = e.target.value;
    this.setState({ optin });

    var maxLength = 2000;
    if (e.target.value.length > maxLength) {
      this.state.charLengthCustomComm[idOptinOther] =
        `${t('character_left')}: ` + e.target.value.substring(0, maxLength) + '/2000';
    } else {
      this.state.charLengthCustomComm[idOptinOther] =
        `${t('character_left')}: ` + (maxLength - e.target.value.length) + '/2000';
    }
  }

  handleSelectFilter = (idFilter, e) => {
    let selectedFilters = this.state.selectedFilters.map(n => n);

    if (e.target.checked) {
      selectedFilters.push(idFilter);
    } else {
      selectedFilters = selectedFilters.filter(fid => fid !== idFilter);
    }

    this.setState({ selectedFilters: selectedFilters }, () => { });
  }

  handleTextAreaChange(e) {
    const { t } = this.props;
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });

    var maxLength = 500;
    if (e.target.value.length > maxLength) {
      this.state.charLength =
        `${t('character_left')}: ` + e.target.value.substring(0, maxLength) + '/500';
    } else {
      this.state.charLength =
        `${t('character_left')}: ` + (maxLength - e.target.value.length) + '/500';
    }
  }

  handleCustomDescriptionChange(e) {
    const { t } = this.props;
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });

    var maxLength = 2000;
    if (e.target.value.length > maxLength) {
      this.state.charLengthCustom =
        `${t('character_left')}: ` + e.target.value.substring(0, maxLength) + '/2000';
    } else {
      this.state.charLengthCustom =
        `${t('character_left')}: ` + (maxLength - e.target.value.length) + '/2000';
    }
  }

  submitUploadForm(e) {
    e.preventDefault();

    let successMsg = '';
    this.setState({
      successMsg
    });

    try {
      if (this.validateForm()) {
        // this.props.showLoader(true, e);
        if (this.state.fileUpload.constructor === Object
          && Object.keys(this.state.fileUpload).length !== 0
          && this.state.fileUpload.url != '' && this.state.fileUpload.file != '') {
          // TODO: Replace with the following after translation text received
          // this.showLoader(true, 'Uploading media..');
          this.showLoader(true, 'submitting');
          axios.put(this.state.fileUpload.url, this.state.fileUpload.file, {
            headers: {
              'Content-Type': this.state.fileUpload.type
            }
          })
            .then((response) => {
              return this.saveUploadDetails();
            })
            .catch((error) => {
              console.log(error);
              // this.props.showLoader(false, false);
              this.showLoader(false);
            });

          let fileUpload = {};
          fileUpload['url'] = '';
          fileUpload['file'] = '';
          fileUpload['type'] = '';
          this.setState({
            fileUpload
          });
        }
        else {
          console.log('save-upload');
          this.saveUploadDetails();
        }
      }
    } catch (error) {
      console.log(error);
      // this.props.showLoader(false, false);
      this.showLoader(false);
    }
  }

  getImageBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }


  saveUploadDetails() {
    try {
      const targetElement = document.querySelector(`.site-title`);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    catch (error) {
      console.log(error);
    }

    try {
      // this.state.fields['image'] = result.split(',')[1];
      let formData = this.state.fields;
      // formData.imageName = imageName;
      // this.state.fields = {};

      this.showLoader(true, 'submitting');
      const { others } = this.state;
      const { selectedFilters } = this.state;
      const { competition, t } = this.props;
      const { currentRound, data } = competition;
      // webhook data
      let customFields = {};
      if (data.otherOptins && data.otherOptins.length > 0) {
        const otherData = data.otherOptins
          .filter(o => !o.deleted).map(oo => {
            if (!oo.deleted) {
              if (oo.type === 'text' || oo.type === 'comment') {

                // webhooks data
                if (others[oo.id]) {
                  customFields[oo.copy] = others[oo.id].value;
                }

                return {
                  id: oo.id,
                  type: oo.type,
                  value: others[oo.id] ? others[oo.id].value : ''
                };
              } else if (oo.type === 'checkbox' || oo.type === 'dropdown' || oo.type === 'radio') {

                // webhooks data
                if (oo.type === 'checkbox') {
                  let newVal = [];
                  oo.options.forEach((ooo, index) => {
                    if (others && others[oo.id] && others[oo.id].selectedValues.includes(ooo.id)) {
                      newVal.push(ooo.copy);
                    }
                  });
                  if (newVal.length > 0) {
                    customFields[oo.copy] = newVal.join(',');
                  }
                } else {
                  oo.options.forEach((ooo, index) => {
                    if (others && others[oo.id] && (others[oo.id].selectedValues.includes(`${ooo.id}`)
                      || others[oo.id].selectedValues.includes(ooo.id))) {
                      customFields[oo.copy] = ooo.copy;
                    }
                  });
                }

                return {
                  id: oo.id,
                  type: oo.type,
                  values: others[oo.id] ? others[oo.id].selectedValues : []
                };
              }
            }
          });
        formData.other = otherData;
      } else {
        delete formData.other;
        console.log("No optional fields", formData)
      }

      if (data.photowallConfigs && data.photowallConfigs.enableFilter && data.photowallFilters
        && data.photowallFilters.length > 0 && selectedFilters.length > 0) {
        formData.selectedFilters = selectedFilters.sort();
      }
      else {
        formData.selectedFilters = [];
      }

      if (data.photowallConfigs && data.photowallConfigs.allowEntryWithoutAsset
        && !formData.competation_id) {
        formData.competation_id = this.props.comp.id;
      }

      if (formData['category']) {
        delete formData['category'];
      }

      if (this.intlTelInputPhoneInst && this.intlTelInputPhoneInst.getNumber()) {
        // formData['phone'] = formData['phone'].value ? (formData['phone'].number).replace(/\s+/g, '') : '';
        formData['phone'] = this.intlTelInputPhoneInst.getNumber();
      }
      console.log('form-new', formData);
      this.props.dispatch(submitImages(
        formData,
        this.props.dispatch,
        this.showLoader,
        this.showLoader
      ));

      if (data && data.webhooks && data.webhooks.find(wh => wh.type === 'optinSent')) {

        console.log("Optin webhook enabled", formData);

        let webhookData = {
          firstname: formData.first_name,
          lastname: formData.last_name,
          email: formData.email,
          mobile: formData.phone ? (formData.phone).replace(/\s+/g, '') : '',
          address: formData.address,
          state: formData.state,
          postcode: formData.postcode,
          tnc: formData['terms_conditions'],
          optin: formData['marketing'],
          dob: formData['date_of_birth'] ? moment(formData['date_of_birth']).format('yyyy-MM-DD') : false,
          customDesc: formData['custom_description'],
          confirmAdult: formData['confirm_adult'],
          idCompetition: data.id,
          idCustomer: data.idCustomer,
          customerTags: data.customerTags ? data.customerTags : [],
          campName: data.name
        };

        if (formData.other) {
          webhookData.otherData = formData.other;
        }

        if (customFields) {
          webhookData.customFields = customFields;
        }

        console.log("Optin webhook data", webhookData);

        this.props.dispatch(webhookRegister(
          webhookData,
          this.props.dispatch
        ));
      }

      // .then(response => {
      //   debugger;
      const resetData = {
        // submitSpin: false,
        // submitLoad: true
      };
      let fields = {};
      fields['first_name'] = '';
      fields['last_name'] = '';
      fields['email'] = '';
      fields['image_description'] = '';
      fields['image'] = '';
      fields['category'] = 0;
      fields['terms_conditions'] = '0';
      fields['phone'] = { countryData: {}, number: '', status: false, value: '' };
      fields['address'] = '';
      fields['postcode'] = '';
      fields['date_of_birth'] = '';
      fields['custom_description'] = '';
      fields['confirm_adult'] = '0';
      fields['state'] = '';
      resetData.fields = fields;
      resetData.others = [];
      resetData.selectedFilters = [];
      resetData.submitted = true;
      var otherRadio = document.getElementsByClassName('othersRadio');
      var otherCheckbox = document.getElementsByClassName('othersCheckbox');
      if (data.optinMarketing) {
        document.getElementsByName('marketing')[0].checked = false;
      }
      if (data.optinTncs) {
        document.getElementsByName('terms_conditions')[0].checked = false;
      }
      if (data.optinConfirmAdult) {
        document.getElementsByName('confirm_adult')[0].checked = false;
      }
      if (data.photowallConfigs && data.photowallConfigs.enableFilter) {
        document.getElementsByName('category').forEach(cat => { cat.checked = false });
      }
      if (data.otherOptins && data.otherOptins.length > 0) {
        Object.keys(data.otherOptins).forEach(function (key) {
          if (data.otherOptins[key].type == 'dropdown' && data.otherOptins[key].deleted != '1') {
            document.getElementsByClassName('othersDropdown')[0].selectedIndex = false;
          }
        });
      }
      if (otherCheckbox) {
        for (var i = 0; i < otherCheckbox.length; i++) {
          if (otherCheckbox[i].type == 'checkbox')
            otherCheckbox[i].checked = false;
        }
      }
      if (otherRadio) {
        for (var i = 0; i < otherRadio.length; i++) {
          if (otherRadio[i].type == 'radio')
            otherRadio[i].checked = false;
        }
      }
      resetData.charLength = `${t('character_left')} 500/500`;
      resetData.charLengthCustom = `${t('character_left')} 2000/2000`;
      resetData.charLengthCustomComm = {};
      this.setState(resetData);
      // this.props.showLoader(false, false);
      // });
    }
    catch (error) {
      console.log(error);
      // this.props.showLoader(false, false);
      this.showLoader(false);
    }
  }

  validatePhoto(file) {
    const { t } = this.props;
    let errors = {};
    let formIsValid = true;
    const filesize = file.size;
    const filetype = file.type;

    if (typeof filetype !== 'undefined') {
      let allowedFiles = ['image/png', 'image/jpeg', 'image/jpg', 'video/mp4', 'video/quicktime', 'video/x-msvideo',
        'video/msvideo', 'video/avi', 'audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/mp4', 'application/pdf'];
      if (!allowedFiles.includes(filetype)) {
        formIsValid = false;
        errors['image'] = `* ${t('photo_upload_img_valid')}`;
      }
    }

    if (typeof filesize !== 'undefined') {
      if (filesize > 5.24288e8) {
        formIsValid = false;
        errors['image'] = `* ${t("photo_upload_size")}`;
      }
    }
    if (errors) {
      this.setState({
        errors: errors
      });
    }
    return formIsValid;
  }

  validateDob(dob) {
    var birthday = moment(dob);
    return birthday.isValid() && birthday.isBefore();
  }

  validateForm() {
    const { t } = this.props;
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    const { others } = this.state;

    if (!fields['first_name'] || fields['first_name'].trim() === '') {
      formIsValid = false;
      // sharp content wall campaign
      if (this.props && this.props.comp && this.props.comp.id == 5484) {
        errors['first_name'] = `* ${t('field_required')}`;
      } else {
        errors['first_name'] = `* ${t('first_name_err')}`;
      }
    }

    if (!fields['last_name'] || fields['last_name'].trim() === '') {
      formIsValid = false;
      // sharp content wall campaign
      if (this.props && this.props.comp && this.props.comp.id == 5484) {
        errors['last_name'] = `* ${t('field_required')}`;
      } else {
        errors['last_name'] = `* ${t('last_name_err')}`;
      }
    }

    console.log('phone-inst', this.intlTelInputPhoneInst);
    console.log('phone-2', this.props.competition.data.optinPhone);
    // if (this.props.competition.data.optinPhone >= 1 && (!fields['phone'] || fields['phone'].value == ''
    //   || isNaN(fields['phone'].value) || !fields['phone'].status)) {
    if (this.props.competition.data.optinPhone >= 1
      && (this.intlTelInputPhoneInst && !this.intlTelInputPhoneInst.isValidNumber())) {
      console.log('phone-error-inst');
      formIsValid = false;
      // this.state.errors.phone
      errors['phone'] = `* ${t('mobile_number_err')}`;
    }

    if (!fields['email'] || fields['email'].trim() === '') {
      formIsValid = false;
      errors['email'] = `* ${t('email_id_err')}`;
    }

    if (typeof fields['email'] !== 'undefined') {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(fields['email'])) {
        formIsValid = false;
        errors['email'] = `* ${t('valid_email_err')}`;
      }
    }

    if ((!fields['image_description'] || fields['image_description'].trim() === '')
      && this.props.comp.photowallConfigs && this.props.comp.photowallConfigs.showComments) {
      formIsValid = false;
      errors['image_description'] = `* ${t('img_desc_err')}`;
    }

    if (!fields['filename'] && this.props.comp.photowallConfigs
      && !this.props.comp.photowallConfigs.allowEntryWithoutAsset) {
      formIsValid = false;
      errors['image'] = `* ${t('upload_photo_err')}`;
    }

    if (!fields['category'] && this.props.comp.photowallConfigs
      && this.props.comp.photowallConfigs.enableFilter
      && this.props.comp.photowallFilters && this.props.comp.photowallFilters.length > 0) {
      formIsValid = false;
      errors['category'] = `* ${t('please_select_one')}`;
    }

    // if (typeof fields['filetype'] !== 'undefined') {
    //   let allowedFiles = ['image/png', 'image/jpeg', 'image/jpg'];
    //   if (!allowedFiles.includes(fields['filetype'])) {
    //     formIsValid = false;
    //     errors['image'] = '*Only jpg/jpeg and png files are allowed.';
    //   }
    // }

    // if (typeof fields['filesize'] !== 'undefined') {
    //   if (fields['filesize'] > 10e6) {
    //     formIsValid = false;
    //     errors['image'] = '*Please upload a file smaller than 10 MB.';
    //   }
    // }

    const { comp } = this.props;

    if (comp.optinDob && (!fields['date_of_birth'] || fields['date_of_birth'].trim() === '' || !this.validateDob(fields['date_of_birth'].trim()))) {
      formIsValid = false;
      errors['date_of_birth'] = `* Date of birth is invalid`;
    }

    if (comp.optinTncs && (!fields['terms_conditions'] || fields['terms_conditions'] == 0)) {
      formIsValid = false;
      errors['terms_conditions'] = '* ' + t('please_select');
      if (comp.optinTncsCopy) {
        errors['terms_conditions'] = errors['terms_conditions'].replace('X', comp.optinTncsCopy);
      }
    }

    if (comp.optinConfirmAdult && (!fields['confirm_adult'] || fields['confirm_adult'] == 0)) {
      formIsValid = false;
      errors['confirm_adult'] = '* Please confirm your age';
    }

    const otherOptins = comp.otherOptins;

    if (otherOptins && otherOptins.length > 0) {
      otherOptins.forEach((oo, key) => {
        if (otherOptins.hasOwnProperty(key) && !otherOptins[key].disabled
          && !otherOptins[key].deleted && otherOptins[key].mandatory) {
          switch (otherOptins[key].type) {
            case 'text':
            case 'date':
            case 'comment':
              if (!others[otherOptins[key].id] || !others[otherOptins[key].id].hasOwnProperty('value')
                || others[otherOptins[key].id].value == null || !others[otherOptins[key].id].value
                || others[otherOptins[key].id].value.trim() == "") {
                errors['customMandatoryOptin'] = '* ' + t('field_required');
                otherOptins[key].hasError = true;
                formIsValid = false;
              } else {
                otherOptins[key].hasError = false;
              }
              break;
            case 'checkbox':
            case 'dropdown':
            case 'radio':
              if (!others[otherOptins[key].id] || !others[otherOptins[key].id].hasOwnProperty('selectedValues')
                || others[otherOptins[key].id].selectedValues.length < 1 || others[otherOptins[key].id].selectedValues[0] == "") {
                errors['customMandatoryOptin'] = '* ' + t('field_required');
                otherOptins[key].hasError = true;
                formIsValid = false;
              } else {
                otherOptins[key].hasError = false;
              }
              break;
          }
        }
      });
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  upVote = (id, vote, index) => {
    if (document.cookie.indexOf('upvote=1') == -1) {
      const { imagesList } = this.props.comp;
      imagesList[index].vote_count = vote + 1;
      this.setState({ imagesList });
      var date = new Date();
      var midnight = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59
      );
      document.cookie = 'upvote=1; expires=' + midnight.toUTCString();

      axios({
        method: 'post',
        url: API_V2_URL + '/image-upload/vote',
        headers: {},
        data: { image_upload_id: id }
      });
    }
  };

  truncateString = (string, length) => {
    if (string.length > length) {
      return string.substring(0, length).trim() + '...';
    }
    else {
      return string;
    }
  }

  getImageUrl = (data) => {
    switch (data.assetTypeId) {
      case 2:
        return "";
      case 3:
        return data.s3_bucket_url + data.thumbnailImageKey;
      default:
        let imageUrl = data.s3_bucket_url + data.s3_key_prefix + data.image_name;
        if (data.aiFrameImageUrl && data.aiFrameImageUrl != '') {
          imageUrl = data.aiFrameImageUrl;
        }
        return imageUrl;
    }
  }

  getAssetLoaderUrl = (data) => {
    let imageUrl = data.s3_bucket_url + data.s3_key_prefix + data.image_name;
    if (data.aiFrameImageUrl && data.aiFrameImageUrl != '') {
      imageUrl = data.aiFrameImageUrl;
    }
    return imageUrl;
  }

  getParentList = () => {
    if (this.state.customFilterImageState > 0 && this.state.filterImageState > 0) {
      return this.processDefaultFilters(this.state.filterImageState, this.state.filteredImagesList);
    }
    if (this.state.customFilterImageState > 0) {
      return this.state.filteredImagesList;
    }
    else {
      return this.props.comp.imagesList;
    }
  }

  customFilter = (e, filterId) => {
    e.preventDefault();
    if (filterId) {
      const { imagesList } = this.props.comp;
      let filteredImagesList = imagesList.filter(image => image.selectedFilters
        && image.selectedFilters.includes(filterId)
      );
      this.trackClickEvent(filterId);
      this.setState({ filteredImagesList: filteredImagesList });
      this.setState({ customFilterImageState: filterId });
    }
  };

  trackClickEvent = (filterId) => {
    const { photowallFilters } = this.props.comp;
    let currentFilterId = this.state.customFilterImageState;
    if (!currentFilterId || currentFilterId !== filterId) {
      let clickCount = localStorage.getItem("clickCount")
      if (!clickCount || clickCount < 10) {
        this.incrementClickCounter();
        // add category click
        this.props.dispatch(trackClick(
          this.props.comp.id,
          0,
          filterId,
          this.props.dispatch
        ));
      }
    }
  };

  incrementClickCounter = () => {
    let clickCount = localStorage.getItem("clickCount");
    localStorage.setItem('clickCount', clickCount ? ++clickCount : 1);
  };

  processDefaultFilters = (filterId, imageList) => {
    switch (filterId) {
      case 1:
        return imageList.sort(function (a, b) {
          var c = new Date(a.created_date);
          var d = new Date(b.created_date);
          return d - c;
        });
      case 2:
        return imageList.sort(function (a, b) {
          return b.vote_count - a.vote_count;
        });
      case 3:
        return randomizeArray(imageList);
      default:
        return imageList;
    }
  };

  mostRecent = e => {
    // const { imagesList } = this.props.comp;
    this.processDefaultFilters(1, this.getParentList());
    // this.setState({ imagesList });
    this.setState({ filterImageState: 1 });
  };

  mostPopular = e => {
    this.processDefaultFilters(2, this.getParentList());
    this.setState({ filterImageState: 2 });
  };

  randomFilter = e => {
    this.processDefaultFilters(3, this.getParentList());
    this.setState({ filterImageState: 3 });

    // var query = window.location.hash.substring(1);
    // var self = this;
    // this.setState({ filterImageState: 3 });
    // axios
    //   .get(API_V2_URL + '/competition/hash/' + query)
    //   .then(function(response) {
    //     self.setState({ hashData: response.data });
    //   });
  };

  handleTwitterShare = twitterShare => {
    window.open(
      'http://www.twitter.com/intent/tweet?url=' +
      encodeURIComponent(twitterShare.url) +
      '&text=' +
      encodeURIComponent(twitterShare.copy),
      'twitter-share-dialog',
      'width=626,height=436'
    );
  };

  handleFacebookShare = facebookShare => {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
      encodeURIComponent(facebookShare.url),
      'facebook-share-dialog',
      'width=626,height=436'
    );
  };

  scrollToAfterLogo = () => {
    var objDiv = document.getElementById("postLogoSect");
    if (objDiv)
      objDiv.scrollIntoView({ behavior: "smooth", block: "start" });

  }

  componentDidMount() {

    this.interval = setInterval(() => this.updateGrid(), 1500);

    var up = false;
    var lastPosition;
    this.intervalScroll = setInterval(function () {
      var $container = $(".card");
      if ($container) {
        var position = $container.scrollTop();
        // var height = $container.scrollHeight;

        if (position === lastPosition) up = !up;
        lastPosition = position;

        if (up) {
          $container.animate({ scrollTop: position - 400 }, 4200);
        } else {
          $container.animate({ scrollTop: position + 400 }, 4200);
        }
      }
    }, 100);

    // let omnihubData = {}
    // const syncOmnihub = (event) => {
    //   console.log('input-data', event);
      // if (event && event.data && isValidJSON(event.data)) {
        // omnihubData = JSON.parse(event.data);
    // if (this.state) {
    //   omnihubData = { "firstname": "New", "lastname": "Test", "email": "newtest@campaignware.com", "mobile": "", "address": "address", "state": "", "postcode": "23456", "tnc": true, "optin": false, "other01": "", "dob": "1999-10-10", "confirmAdult": true, "customDesc": "", "idCompetition": 8433, "other": [{ "id": 19172, "type": "dropdown", "values": [62502] }] };
    //   console.log('input-data-1', omnihubData);
    //   let optinState = this.state.fields;
    //   let state = {
    //     ...this.state,
    //     fields: {
    //       ...optinState,
    //       first_name: returnValueIfNotEmpty(omnihubData.firstname),
    //       last_name: returnValueIfNotEmpty(omnihubData.lastname),
    //       email: returnValueIfNotEmpty(omnihubData.email),
    //       address: returnValueIfNotEmpty(omnihubData.address),
    //       postcode: returnValueIfNotEmpty(omnihubData.postcode),
    //       state: returnValueIfNotEmpty(omnihubData.state),
    //       date_of_birth: returnValueIfNotEmpty(omnihubData.dob)
    //     }
    //   };
    //   if (omnihubData['other']) {
    //     let dropdown = omnihubData['other'].find(oo => oo.id == this.matchReseesState['source']);
    //     console.log('other-optin', dropdown);
    //     let dropdownValue = '';
    //     if (dropdown && dropdown['values'] && dropdown['values'][0]) {
    //       dropdownValue = dropdown['values'][0];
    //       console.log('other-optin-val', dropdownValue);
    //       console.log('other-optin-val-curr', this.matchReseesStateAnswers[dropdownValue]);
    //       state.others = {
    //           [this.matchReseesState['target']]: {
    //             selectedValues: [this.matchReseesStateAnswers[dropdownValue]]
    //           }
    //       };
    //     }
    //   }
    //   this.setState(state);
    // }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.intervalScroll);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    const { competition, t } = this.props;
    const { data } = competition;

    console.log('newone-phone-out');
    if (this.intlTelInputPhoneEle.current && this.intlTelInputPhoneEle.current.classList
      && !this.intlTelInputPhoneEle.current.classList.contains('phone-inst-started')
      && window.intlTelInput) {
      console.log('newone-phone-inst');
      this.intlTelInputPhoneEle.current.classList.add('phone-inst-started');

      this.intlTelInputPhoneInst = window.intlTelInput(this.intlTelInputPhoneEle.current, {
        initialCountry: data.phoneDefaultCountry ? data.phoneDefaultCountry : "au",
        countrySearch: false,
        separateDialCode: true,
        formatAsYouType: false,
        formatOnDisplay: false,
        countryOrder: this.preferredCountries,
        // utilsScript: "https://loadtest.campaignware.com/src-assets-dir/common/js/intl-tel-input/utils.js",
        utilsScript: "/src-assets-dir/common/js/intl-tel-input/utils.js",
      });
      console.log('phone-1-inst', this.intlTelInputPhoneInst);
    }

    const hasEmbedFooter = showEmbedFooter();
    if (hasEmbedFooter) {
      window.parent.postMessage({
        type: "CAMPAIGNWARE-FOOTER",
        showMadeWithBv: data ? data.showMadeWithBv : '',
        privacypolicy: data ? data.privacypolicy : '',
        privacypolicyTxt: t('privacy_policy'),
        tncs: data ? data.tncs : '',
        tncsTxt: t('term_condition'),
        url: 'https://www.campaignware.com/?utm_source=footer+button&utm_medium=campaigns&utm_campaign=footer+button+landing+page'
      },
        "*");
    }
  }

  handleChangeShare = (state) => {
    const scrollRef = this.socialShareRef.current
    const currentPosition = scrollRef.scrollLeft;
    const position = window.innerWidth > 650 ? 50 : 73;
    let scrollPosition = state === 'previous' ? Math.round(((currentPosition - position) / position) * position) : Math.round(((currentPosition + position) / position) * position)
    scrollRef.scrollLeft = scrollPosition;
  }

  triggerVBooster = (vBooster) => {
    console.log('vBooster', vBooster);
    console.log('vBooster-props', this.props);

    if (vBooster.ctaLink && vBooster.ctaLink != "") {
      window.open(vBooster.ctaLink, '_blank');
    }

    // let token = localStorage.getItem('token');
    let idOptin = this.props.competition.submittedIdOptin;
    if (vBooster.idCompetition && vBooster.id && idOptin) {

      var params = {
        idComp: vBooster.idCompetition,
        idCompVB: vBooster.id,
        idOptin
      }

      this.props.dispatch(
        updateVBPInner(
          this.props.competition.data.id,
          params,
          this.props.dispatch
        )
      );

      // const cookies = new Cookies();
      // cookies.set('vBEntries-' + vBooster.idCompetition, vBEntriesExisting);

      // var vBEntries = cookies.get('vBEntries-' + vBooster.idCompetition);

    }
  }

  renderCustomFieldsActual = (oo, others, otherIndex, data) => {
    switch (oo.type) {
      case 'text':
        return <div className="optin-row" key={otherIndex}>
          <div className='optin-col'>
            <FormControl
              type="text"
              value={(others[oo.id] && others[oo.id].value) || ''}
              placeholder={oo.copy}
              onFocus={this.sendParentScrollMessage}
              onChange={(e) => this.handleChangeOptinOther(oo.id, e)}
            />
          </div>
        </div>;
      case 'comment':
        return <div className="optin-row" key={otherIndex}>
          <div className='optin-col'>
            <FormControl
              rows="4"
              componentClass="textarea"
              className='textarea'
              value={(others[oo.id] && others[oo.id].value) || ''}
              placeholder={oo.copy}
              onFocus={this.sendParentScrollMessage}
              onChange={(e) => this.handleChangeOptinOtherComm(oo.id, e)}
              maxLength='2000'
            />
            <div style={{ marginTop: 5, color: data.primaryColor }}>{this.state.charLengthCustomComm[oo.id]
              ? this.state.charLengthCustomComm[oo.id] : this.state.charLengthCustom}</div>
          </div>
        </div>;
      case 'checkbox':
        return <div className="optin-row custom-fld pull-left text-left" key={otherIndex}>
          <label style={{ color: data ? data.primaryColor : '' }} className="">{oo.copy} </label>
          {oo.options.filter(o => !o.deleted).map((ooo, index) =>
            <div class="custom-control custom-checkbox custom-control-inline" key={index}>
              <input type="checkbox" id={`checkGroup${otherIndex}${index}`} class="custom-control-input" onClick={(e) => this.handleSelectOptinOtherOption(oo.id, ooo, e)} />
              <label style={{ color: data ? data.primaryColor : '' }} class="custom-control-label" for={`checkGroup${otherIndex}${index}`} dangerouslySetInnerHTML={{ __html: ooo.copy }} />
            </div>
            // <label className="checkbox-inline pull-left" key={index}>
            //   <input type="checkbox" className="othersCheckbox" onClick={(e) => this.handleSelectOptinOtherOption(oo.id, ooo, e)} /><span dangerouslySetInnerHTML={{__html: ooo.copy}}/>
            // </label>
          )}
        </div>;
      case 'dropdown':
        return <div className="optin-row custom-fld pull-left text-left" key={otherIndex}>
          <label style={{ color: data ? data.primaryColor : '' }} className="">{oo.copy} </label>
          <select className="othersDropdown form-control" onChange={(e) => this.handleSelectOptinOtherOptionSingle(oo.id, e)}
            value={this.state && this.state.others && this.state.others[oo.id]
              && this.state.others[oo.id].selectedValues && this.state.others[oo.id].selectedValues[0]
              ? this.state.others[oo.id].selectedValues[0] : ''}>
            <option value="" selected="selected">Select</option>
            {oo.options.filter(o => !o.deleted).map((ooo, index) =>
              <option value={ooo.id} key={index}>{ooo.copy}</option>
            )}
          </select>
        </div>;
      case 'radio':
        return <div className="optin-row custom-fld pull-left text-left" key={otherIndex}>
          <label style={{ color: data ? data.primaryColor : '' }} className="">{oo.copy} </label>
          {oo.options.filter(o => !o.deleted).map((ooo, index) =>
            <div class="custom-control custom-radio custom-control-inline" key={index}>
              <input type="radio" id={`radioGroup${otherIndex}${index}`} class="custom-control-input" name={`radioGroup${oo.id}`} onClick={(e) => this.handleClickOptinOtherOptionSingle(oo.id, ooo, e)} />
              <label style={{ color: data ? data.primaryColor : '' }} class="custom-control-label" for={`radioGroup${otherIndex}${index}`} dangerouslySetInnerHTML={{ __html: ooo.copy }} />
            </div>
            // <label className="radio-inline pull-left" key={index}>
            //   <input type="radio" className="othersRadio" name={`radioGroup${oo.id}`} onClick={(e) => this.handleClickOptinOtherOptionSingle(oo.id, ooo, e)} /> <span dangerouslySetInnerHTML={{__html: ooo.copy}}/>
            // </label>
          )}
        </div>;
    }
  }

  render() {

    let noBorderRadius = (this.props && this.props.competition
      && this.props.competition.data && this.props.competition.data.defaultShape == 2);

    this.defaultShape = this.props && this.props.competition
          && this.props.competition.data && this.props.competition.data.defaultShape;
              // $scope.classRadius = $scope.defaultShape == 2 ? 'no-border-radius' : '';
    if (this.defaultShape && this.shapesList[this.defaultShape]) {
      this.classRadius = this.shapesList[this.defaultShape];
    }

    const cookies = new Cookies();
    let modalContent = '';
    console.log('props-new', this.props.comp);
    if (this.props.comp && this.props.comp.showAgeRestrictionPopup) {
      console.log('p-nish', this.props.comp.showAgeRestrictionPopup);

      modalContent = (
        <Popup
          open={!cookies.get('age-restriction-' + this.props.comp.id)}
          contentStyle={{
            width: "auto",
            padding: "0 15px 18px",
            margin: "18px auto auto",
            background: "#FFFFFF",
            border: "0px",
            borderRadius: (noBorderRadius ? "0px" : '10px')
          }}
          overlayStyle={{ background: "rgba(0, 0, 0, 0.6)" }}
          lockScroll={true}
          closeOnEscape={false}
          closeOnDocumentClick={false}
        >
          <div className={"age-restrict-dialog"}>
            <div className={"modal-body"}>
              <h3><Trans i18nKey="are_you_over_18" /></h3>
            </div>
            <div className={"modal-footer"}>
              <button type="button" className={"btn btn-default"}
                onClick={this.setAgeRestrictionAcceptance}><Trans i18nKey="yes" /></button>

              <button type="button" className={"btn btn-default"}
                onClick={this.showAgeRestrictionPopupError}><Trans i18nKey="no" /></button>
            </div>

            {this.state.showAgeRestrictionPopupErr ?
              <div className={"modal-error"}><Trans i18nKey="are_you_over_18_err" /></div>
              : ''
            }
          </div>
        </Popup>
      );
    }

    if (this.state.successMsg) {
      setTimeout(
        function () {
          this.state.successMsg = '';
        }.bind(this),
        5000
      );
    }
    if (this.state.responseError) {
      setTimeout(
        function () {
          this.state.responseError = '';
        }.bind(this),
        5000
      );
    }

    const { competition, t } = this.props;
    const { data, enabledSocialNetworks } = competition;
    let submitSpin = this.state.submitSpin;
    let submitLoad = this.state.submitLoad;
    let successMsg = '';
    if (competition.createImageStatus) {
      submitSpin = false;
      submitLoad = true;
      successMsg = t('image_add_successfully');
    }

    const { others } = this.state;

    const hasEmbedFooter = showEmbedFooter();

    if (data) {

      const socialShareTitle = data.shareEnabled && data.socialSharingTextTitle ? data.socialSharingTextTitle : data.detail ? (data.detail).replace(/<[^>]*>/g, "").replace(/\\s+/g, " ").trim() : '';
      const socialShareUrl = data.seoUrl && data.seoUrl != '' ? data.seoUrl : `${data.webapp}#${data.hash}`;
      const socialShareDescription = data.shareEnabled && data.socialSharingTextDescription ? data.socialSharingTextDescription : data.description ? (data.description).replace(/<[^>]*>/g, "").replace(/\\s+/g, " ").trim() : '';
      const socialShareMedia = data.shareEnabled && data.socialSharingBackgroundImageUrl ? data.socialSharingBackgroundImageUrl : (data.logoBg && data.logoBg.file) ? (data.logoBg.file) : '';


      let compSpecificFields = {
        'image-upload': [
          {
            // after custom description
            id: 'category',
            model: 'category',
            name: 'Categories',
            // consider the ones inserted dynamically
            insertIndex: 9,
            toIgnore: true
          },
          {
            // first
            id: 'media',
            model: 'media',
            name: 'Media upload',
            insertIndex: 0,
            toIgnore: true
          },
          {
            // after state
            id: 'text',
            model: 'text',
            name: 'Text entry box',
            // consider the ones inserted dynamically
            insertIndex: 9,
            toIgnore: true
          }
        ]
      };

      let leadCaptureFields = [
        {
          id: 'optinFirstname',
          value: this.state.fields.first_name,
          model: 'firstname',
          placeholder: 'first_name',
          name: 'first_name',
          type: 'text',
          error: {
            field: this.state.errors.first_name,
            message: 'err_first_name'
          }
        },
        {
          id: 'optinLastname',
          value: this.state.fields.last_name,
          model: 'lastname',
          placeholder: 'last_name',
          name: 'last_name',
          type: 'text',
          error: {
            field: this.state.errors.last_name,
            message: 'err_last_name'
          }
        },
        {
          id: 'optinEmail',
          value: this.state.fields.email,
          model: 'email',
          placeholder: 'email',
          name: 'email',
          type: 'text',
          error: {
            field: this.state.errors.email,
            message: 'email_addres_err'
          }
        },
        {
          id: 'optinPhone',
          value: this.state.fields.phone && this.state.fields.phone.value || '',
          model: 'phone',
          type: 'text',
          error: {
            field: this.state.errors.phone,
            message: 'mobile_number_err'
          }
        },
        {
          id: 'optinDob',
          value: this.state.fields.date_of_birth,
          model: 'dob',
          placeholder: 'date_of_birth',
          name: 'date_of_birth',
          type: 'date',
          error: {
            field: this.state.errors.date_of_birth,
            message: 'dob_err'
          }
        },
        {
          id: 'optinAddress',
          value: this.state.fields.address,
          model: 'address',
          placeholder: 'address',
          name: 'address',
          type: 'text',
          error: {
            field: this.state.errors.address,
            message: 'address_err'
          }
        },
        {
          id: 'optinState',
          value: this.state.fields.state,
          model: 'state',
          placeholder: 'state',
          name: 'state',
          type: 'text',
          error: {
            field: this.state.errors.state,
            message: 'state_err'
          }
        },
        {
          id: 'optinPostcode',
          value: this.state.fields.postcode,
          model: 'postcode',
          placeholder: 'postcode',
          name: 'postcode',
          type: 'text',
          error: {
            field: this.state.errors.postcode,
            message: 'postcode_err'
          }
        },
        {
          id: 'optinCustomDesc',
          value: this.state.fields.custom_description,
          model: 'customDesc',
          placeholder: 'comments',
          type: 'text',
          error: {
            field: 'customDescError',
            message: 'comments_error'
          }
        },
      ];

      let otherLCFields = [
        {
          id: 'optinTncs',
          model: 'tnc',
          placeholder: 'confirm_adult',
          type: 'text',
          error: {
            field: 'tncError',
            message: 'terms_condition_18'
          }
        },
        {
          id: 'optinMarketing',
          model: 'optin',
          placeholder: 'confirm_adult',
          type: 'text'
        },
        {
          id: 'optinConfirmAdult',
          model: 'confirmAdult',
          placeholder: 'confirm_adult',
          type: 'text',
          error: {
            field: 'confirmAdultError',
            message: 'confirm_adult_err'
          }
        },
      ];

      if (data.isLCFOrderingEnabled) {
        leadCaptureFields = leadCaptureFields.concat(otherLCFields);
      }

      if (data.otherOptins && data.otherOptins.length > 0) {
        data.otherOptins.forEach(function (oo) {
          if (oo.disabled || oo.deleted) {
            return;
          }
          oo.isCustom = true;
          oo.model = 'custom';
          // if (oo.index != null) {
          //   console.log('index', oo);
          //   that.leadCaptureFields[oo.index - 1] = oo;
          // } else {
          console.log('noindex', oo)
          leadCaptureFields.push(oo);
          // }
        });
      }

      if (!data.isLCFOrderingEnabled) {
        leadCaptureFields = leadCaptureFields.concat(otherLCFields);
        if (compSpecificFields[data.type]) {
          for (var csfKey in compSpecificFields[data.type]) {
            if (compSpecificFields[data.type][csfKey]) {
              let insertIndex = compSpecificFields[data.type][csfKey]['insertIndex'];
              leadCaptureFields.splice(insertIndex, 0, compSpecificFields[data.type][csfKey]);
            }
          }
        }
      }

      // leadCaptureFields.forEach((field, fieldIndex) => {
      //   if (!field.isCustom && !field.toIgnore) {
      //     if (!data[field.id] || data[field.id] == 0 || data[field.id] == null) {
      //       leadCaptureFields.splice(fieldIndex, 1);
      //     }
      //   }
      // })

      for (let i = leadCaptureFields.length - 1; i >= 0; i -= 1) {
        let field = leadCaptureFields[i];
        if (!field.isCustom && !field.toIgnore) {
          if (!data[field.id] || data[field.id] == 0 || data[field.id] == null) {
            leadCaptureFields.splice(i, 1);
          }
        }
      }

      console.log('lead-1', leadCaptureFields);

      let leadCaptureFieldsHolder = [];
      let leadCaptureFieldsSorted = [];

      let fieldsOrderingListData = {};
      if (data.fieldsOrdering && data.fieldsOrdering != '') {
        var fieldsOrderingList = data.fieldsOrdering.split(',');
        if (fieldsOrderingList && fieldsOrderingList.length > 0) {
          fieldsOrderingList.forEach((fol, folIndex) => {
            var fieldsSplit = fol.split('-');
            if (fieldsSplit && fieldsSplit.length == 2) {
              fieldsOrderingListData[fieldsSplit[0]] = fieldsSplit[1];
            }
          });
        }
      }
      console.log('fields-order', fieldsOrderingListData);
      console.log('lead-2', leadCaptureFields);

      if (data.isLCFOrderingEnabled) {
        for (var folIndex in fieldsOrderingListData) {
          if (fieldsOrderingListData[folIndex] && compSpecificFields[data.type]
            && compSpecificFields[data.type]) {

            let matchingLcfField = compSpecificFields[data.type].find((csf) => {
              return csf.id == folIndex;
            });
            if (matchingLcfField) {
              matchingLcfField.insertIndex = fieldsOrderingListData[folIndex];
              leadCaptureFields.push(matchingLcfField);
            }
          }
        }

        leadCaptureFields.forEach((field, fieldIndex) => {
          if (field.id == 'text' && data.photowallConfigs
            && !data.photowallConfigs.showComments) {
            // leadCaptureFields.splice(fieldIndex, 1);
            delete leadCaptureFields[fieldIndex];
            return;
          }

          if (field.id == 'category' && ((data.photowallConfigs
            && !data.photowallConfigs.enableFilter)
            || !data.photowallFilters || data.photowallFilters.length == 0)) {
            // leadCaptureFields.splice(fieldIndex, 1);
            delete leadCaptureFields[fieldIndex];
            return;
          }

          if (!field.isCustom && !field.toIgnore) {
            if (data[field.id] && data[field.id] > 0 && data[field.id] != null) {
              if (!field.restrictedTypes || !field.restrictedTypes.includes(data.type)) {
                leadCaptureFieldsSorted.push([field.id, data[field.id]]);
              }
            }
          } else if (field.isCustom) {
            if (!field.disabled) {
              leadCaptureFieldsSorted.push([field.id, field.index]);
            }
          } else if (field.toIgnore && fieldsOrderingListData[field.id] >= 0) {
            leadCaptureFieldsSorted.push([field.id, fieldsOrderingListData[field.id]])
          }
        });

        console.log('lead-3', leadCaptureFieldsSorted);

        leadCaptureFieldsSorted.sort(function (a, b) {
          return a[1] - b[1];
        });

        leadCaptureFieldsSorted.forEach((field, fieldIndex) => {
          var searchField = leadCaptureFields.find((lcf) => {
            return lcf && lcf.id === field[0];
          });
          if (searchField) {
            leadCaptureFieldsHolder.push(searchField);
          }
        });

        leadCaptureFields = leadCaptureFieldsHolder;
      }

      // leadCaptureFields.forEach((field, fieldIndex) => {
      //   if (field && !field.isCustom) {
      //     data[field.id] = data[field.id] && data[field.id] > 0 && data[field.id] != null;
      //   }
      //   if (!field) {
      //     console.log('empty-field', field);
      //     leadCaptureFields.splice(fieldIndex, 1);
      //   }
      // });

      // console.log('disabled-fields', leadCaptureFields);


      let voteOpen = true;
      // determine if competition is open
      if (data.startDate && data.endDate) {
        let startDate = new Date(data.startDate);
        let endDate = new Date(data.endDate);
        let now = new Date();
        voteOpen = startDate <= now && endDate >= now;
      }

      let footerCont = (<div className='footer'>
        {data.tncs || data.privacypolicy || data.showMadeWithBv ? <div className={'fixed-container'}>
          {data.tncs || data.privacypolicy || data.showMadeWithBv ? (
            <div className={'floatingFooter ' + (!data.tncs && !data.privacypolicy ? 'floatingFooterHide' : '')}>
              {data.tncs ? (
                <a href={data.tncs} target='_blank'>
                  <Trans i18nKey="terms_condition" />
                </a>
              ) : null}
              {data.tncs && data.privacypolicy ? ' - ' : null}
              {data.privacypolicy ? (
                <a href={data.privacypolicy} target='_blank'>
                  <Trans i18nKey="privacy_policy" />
                </a>
              ) : null}
            </div>
          ) : null}
          {data.showMadeWithBv ?
            <div className='made-with-bv'>
              <div className='made-with-bv-desktop'>
                <a href="https://www.campaignware.com/?utm_source=footer+button&utm_medium=campaigns&utm_campaign=footer+button+landing+page" target="_blank" className="p-l-20 p-r-20"><img className="footer-logo" src="https://benchvote-media-assets.s3-ap-southeast-2.amazonaws.com/common-images/campaignware_footer_logo.png" /></a>
                {/* <a href="https://www.campaignware.com/?utm_source=footer+button&utm_medium=campaigns&utm_campaign=footer+button+landing+page" target="_blank" className="btn btn-sm p-l-20 p-r-20"><Trans i18nKey="try_benchvote" /></a> */}
                {/* <a href="https://www.campaignware.com/?utm_source=activations&utm_medium=activationfooter&utm_campaign=clickthroughs"
                target="_blank">
                  <img src={'https://benchvote-media-assets.s3-ap-southeast-2.amazonaws.com/common-images/bv_logo_light.png'}
                    alt="Made with BV" className='made-with-bv-image'/></a> */}
              </div>
              <div className='made-with-bv-mobile'>
                <div class="build-with-bv">
                  <a href="https://www.campaignware.com/?utm_source=footer+button&utm_medium=campaigns&utm_campaign=footer+button+landing+page" target="_blank"><img className="footer-logo" src="https://benchvote-media-assets.s3-ap-southeast-2.amazonaws.com/common-images/campaignware_footer_logo.png" /></a>
                  {/* <a href="https://www.campaignware.com/?utm_source=footer+button&utm_medium=campaigns&utm_campaign=footer+button+landing+page" target="_blank"><Trans i18nKey="try_benchvote" /></a> */}
                </div>
                {/* <a href="https://www.campaignware.com/?utm_source=activations&utm_medium=activationfooter&utm_campaign=clickthroughs"
                target="_blank">
                  <img src={'https://benchvote-media-assets.s3-ap-southeast-2.amazonaws.com/common-images/bv_logo_dark.png'}
                    alt="Made with BV" className='made-with-bv-image'/></a> */}
              </div>
            </div> : null}
        </div> : null}
      </div>);

      if (voteOpen) {
        let imagesList = this.getParentList();
        let voteCont = (
          <div className='vote-cont'>
            <div className='loading-rounds' />
          </div>
        );
        const facebookShare =
          enabledSocialNetworks &&
          enabledSocialNetworks.find(sn => sn.name === 'Facebook');
        const twitterShare =
          enabledSocialNetworks &&
          enabledSocialNetworks.find(sn => sn.name === 'Twitter');

        const internalStyle =
          `.custom-control-label::before {
            border: 2px solid ${data.borderColor};
          }
          .form-control {
            outline: 2px solid ${data.borderColor};
          }`;

        voteCont = (
          <div className={this.classRadius}>

          <style>
            {internalStyle}
          </style>
            {modalContent}
            {/* <div onClick={() => this.showLoader(true, 'uploading loading..')}>Click me
            </div> */}
            {/* <div onClick={() => this.setState({ loader: true})}>Click me
            </div> */}
            <Popup
              open={this.state.loader}
              contentStyle={{
                width: "auto",
                padding: "0px",
                background: "transparent",
                border: "0px"
              }}
              overlayStyle={{ background: "rgba(0, 0, 0, 0.6)" }}
              lockScroll
              closeOnEscape={false}
              closeOnDocumentClick={false}
            >
              <div class="loader">
                <div class="css-1ujetdd">
                  <div class="css-17s2e5o"></div>
                  <div class="css-18f6jht"></div>
                  <div class="css-845auu"></div>
                  <div class="css-1q3039v"></div>
                  <div class="css-1jhp186"></div>
                  <div class="css-e9j6i3"></div>
                  <div class="css-1dt8jqj"></div>
                  <div class="css-1hrny51"></div>
                </div>
              </div>
              <div style={{ color: data ? data.primaryColor : '' }}
                className='loader-text'><Trans i18nKey={this.state.loaderText} />
              </div>
            </Popup>

            {setCustomInputStyling(data.primaryColor ? data.primaryColor : '#fff')}
            <div className='logo-form-group'>
              {data && data.logoBg ?
              <div className='logos-cont'>
                {/* {data.logoBg ? <img src={data.logoBg.file} className='pl-logo logo-image img-fluid center-block' /> : null} */}
                {!data.logoFullscreen ? (
                  <img src={data.logoBg.file} className={'logo-image'} />)
                  : (<div ng-if="logoFullscreen" onClick={this.scrollToAfterLogo}
                    style={{background: `url(${data.logoBg.file}) no-repeat center center`, height: '100vh',
                        backgroundSize: 'cover', cursor: 'pointer'}}></div>)
                }
              </div> : null}
              <div id="postLogoSect" style={{ visibility: 'hidden' }}></div>
              {data.sponsorsBg && data.sponsorsTop == 1 ?
                (
                  <div className='logos-cont sponsors'>
                    {((data.sponsorsLink && data.sponsorsLink != '') ?
                      (
                        <a href={data.sponsorsLink} target="_blank">
                          <img src={data.sponsorsBg.file} className='sp-logo logo-image' />
                        </a>
                      ) : (
                        <img src={data.sponsorsBg.file} className='sp-logo logo-image' />
                      ))}
                  </div>
                ) : null}
              <div
                style={{
                  color: data ? data.primaryColor : ''
                }}
                className='vote-cont'
              >
                <svg height="0" width="0">
                  <defs>
                    <clipPath id="infoBottomClip" clipPathUnits="objectBoundingBox">
                        <polygon points="1.02 -0.01, 0.5 1, -0.02 -0.01"/>
                    </clipPath>
                  </defs>
                </svg>
                <svg height="0" width="0">
                  <defs>
                    <clipPath id="infoBottomBorderClip" clipPathUnits="objectBoundingBox">
                        <polygon points="0 0.72, 0.5 0.98, 1 0.72, 1 0.75, 0.5 1, 0 0.75"/>
                    </clipPath>
                  </defs>
                </svg>

                <h1 className={'site-title'} style={{ color: data ? data.primaryColor : '' }} dangerouslySetInnerHTML={{ __html: data.detail }} />
                {!successMsg ? <p style={{ color: data ? data.primaryColor : '' }}
                  dangerouslySetInnerHTML={{
                    __html: data.description
                  }}
                  className={'site-description'}
                /> : null}
                {data && !successMsg ? (
                  <form
                    className='photouploadform'
                    method='post'
                    name='photoUploadForm'
                    onSubmit={this.submitUploadForm}
                  >
                    <div className='upload-form'>

                      {leadCaptureFields && leadCaptureFields.length > 0 ? (
                        <div>
                          {leadCaptureFields
                            .filter(o => (!o.isCustom || (!o.disabled && !o.deleted)))
                            .map((oo, otherIndex) => {
                              switch (oo.model) {
                                case "phone":
                                  return (
                                    <div className='optin-row'>
                                      <div className='optin-col'>
                                        {/* <FormControl
                                  type='text'
                                  placeholder={t('phone')}
                                  onChange={this.handleChange}
                                  name='phone'
                                  value={this.state.fields.phone || ''}
                                /> */}
                                        {/* <IntlTelInput
                                          containerClassName="intl-tel-input"
                                          inputClassName="form-control"
                                          value={this.state.fields.phone && this.state.fields.phone.value || ''}
                                          preferredCountries={this.preferredCountries}
                                          defaultCountry={(data.phoneDefaultCountry && data.phoneDefaultCountry != null)
                                            ? data.phoneDefaultCountry : 'au'}
                                          placeholder={t('phone')}
                                          separateDialCode={true}
                                          onPhoneNumberChange={(status, value, countryData, number) => this.handleMobileNumber({ status, value, countryData, number })}
                                          onSelectFlag={(value, countryData, number, status) => this.handleMobileNumber({ value, countryData, number, status })}
                                        /> */}

                                        {/* <IntlTelInput
                                            initOptions={{
                                                initialCountry: "us",
                                            }}
                                        /> */}

                                        <input type="tel" id="phone" className="form-control"
                                          // value={this.state.fields.phone && this.state.fields.phone.value || ''}
                                          name='phone'
                                          placeholder={t('mobile_number')} ref={this.intlTelInputPhoneEle} />

                                        {/* <FormControl
                                          type="tel" ref={this.intlTelInputPhoneEle}
                                          id="phone" className="form-control"
                                          placeholder={t('mobile_number')}
                                          // onChange={this.handleChange}
                                          onChange={this.handleMobileNumber}
                                          name={oo.name}
                                          value={this.state.fields.phone && this.state.fields.phone.value || ''}
                                          // value={oo.value || ''}
                                        /> */}

                                      </div>
                                      <div className='errorMsg'>{this.state.errors.phone}</div>
                                    </div>
                                  )
                                case "customDesc":
                                  return (

                                    <div className='optin-row'>
                                      <div className='optin-col'>
                                        <FormControl
                                          componentClass='textarea'
                                          style={{ height: 120 }}
                                          placeholder={t('comments')}
                                          onChange={this.handleCustomDescriptionChange}
                                          name='custom_description'
                                          value={this.state.fields.custom_description || ''}
                                          maxLength='2000'
                                        />
                                      </div>
                                      <div className='charLength' style={{ color: data ? data.primaryColor : '' }}>
                                        {this.state.charLengthCustom ? this.state.charLengthCustom : `${t('character_left')}: 2000/2000`}
                                      </div>
                                    </div>
                                  )
                                case "confirmAdult":
                                  return (
                                    <div className="optin-row custom-fld pull-left text-left">
                                      <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="customCheck3" onChange={this.handleChange} name='confirm_adult' value='1' />
                                        <label style={{ color: data ? data.primaryColor : '' }} class="custom-control-label optin-marketing-label"
                                          for="customCheck3">
                                          <Trans i18nKey="confirm_adult" />
                                        </label>
                                      </div>
                                      <div className='errorMsg custom-fld text-center'>
                                        {this.state.errors.confirm_adult}
                                      </div>
                                    </div>
                                  )
                                case "optin":
                                  return (
                                    <div className="optin-row custom-fld pull-left text-left">

                                      <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="customCheck1" onChange={this.handleChange} name='marketing' value='1' />
                                        <label style={{ color: data ? data.primaryColor : '' }} class="custom-control-label optin-marketing-label"
                                          for="customCheck1" dangerouslySetInnerHTML={{ __html: data.optinMarketingCopy }} />
                                      </div>
                                      {/* <label className="checkbox-inline pull-left">
                              <input
                                type="checkbox"
                                onChange={this.handleOptinChange}
                                name='marketing'
                                value='1'
                              />{data.optinMarketingCopy}
                            </label> */}
                                      <div className='errorMsg'>
                                        {this.state.errors.marketing}
                                      </div>
                                    </div>
                                  )
                                case "tnc":
                                  return (
                                    <div className="optin-row custom-fld pull-left text-left">
                                      <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="customCheck2" onChange={this.handleChange} name='terms_conditions' />
                                        <label style={{ color: data ? data.primaryColor : '' }} class="custom-control-label optin-tnc-label"
                                          for="customCheck2" dangerouslySetInnerHTML={{ __html: data.optinTncsCopy }} />
                                      </div>
                                      <div className='errorMsg custom-fld text-center'
                                        dangerouslySetInnerHTML={{ __html: this.state.errors.terms_conditions }} />
                                    </div>
                                  )
                                case "dob":
                                  return (
                                    <div className='optin-row'>
                                      <div className='charLength' style={{ color: data ? data.primaryColor : '' }}>
                                        <Trans i18nKey="dob" />
                                      </div>
                                      <div className='optin-col'>
                                        <FormControl
                                          className='date_of_birth'
                                          type='date'
                                          placeholder="dd/mm/yyyy"
                                          name='date_of_birth'
                                          onChange={this.handleChange}
                                          value={this.state.fields.date_of_birth || ''}
                                        />
                                      </div>
                                      <div className='errorMsg'>
                                        {this.state.errors.date_of_birth}
                                      </div>
                                    </div>
                                  )
                                case "custom":
                                  return (
                                    <div className="optin-row">
                                      {this.renderCustomFieldsActual(oo, others, otherIndex, data)}
                                      {oo.hasError ? (
                                        <div className='errorMsg'>
                                          {this.state.errors.customMandatoryOptin}
                                        </div>
                                      ) : null}
                                    </div>
                                  )
                                case "media":
                                  return (
                                    <div className='optin-row'>
                                      <div className='optin-col upload-btn-wrapper uploadimage'
                                        style={{ outline: '2px solid ' + (data ? data.borderColor : '') }}>
                                        <div className='uploadimage-inner'>
                                          <div className='upload-placeholder'><span className='upload-plus'></span><Trans i18nKey="upload_image" /></div>
                                          <FormControl
                                            type='file'
                                            onChange={this.handleChangeFile}
                                            name='image'
                                            inputRef={input => this.imageUploadElement = input}
                                            value={this.state.fields.image || ''}
                                            style={{ backgroundColor: data ? data.buttonColor : '',
                                              color: data ? data.primaryColor : '' }}
                                            accept="'image/png', 'image/jpeg', 'image/jpg', 'video/mp4', 'video/quicktime',
                                  'video/x-msvideo', 'video/msvideo', 'video/avi', 'audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/mp4',
                                  'application/pdf', .jpg, .jpeg, .png, .mp4, .mov, .avi, .mp3, .wav, .m4a, .pdf"
                                          // tabindex="4"

                                          />{' '}
                                          {this.state.fields.filename}
                                          <div className={"file-desc " + (this.state.fields.filename ? 'file-desc-no-pad' : '')}
                                            onClick={this.handleImageUploadClick}>
                                            <Trans i18nKey="photowall_allowed_types" />
                                          </div>
                                        </div>
                                      </div>
                                      <div className='errorMsg'>{this.state.errors.image}</div>
                                    </div>
                                  )
                                case "category":
                                  return (
                                    <div className='optin-row custom-fld pull-left text-left'>
                                      <label style={{ color: data ? data.primaryColor : '' }} className=""><Trans i18nKey="category" /></label>
                                      {data.photowallFilters && data.photowallFilters.map((filter, filterIndex) =>
                                        <div class="custom-control custom-checkbox custom-control-inline" key={filterIndex}>
                                          <input type="checkbox" id={`categorySet${filterIndex}`} name="category" onChange={this.handleCategoryChange}
                                            class="custom-control-input" onClick={(e) => this.handleSelectFilter(filter.id, e)} />
                                          <label style={{ color: data ? data.primaryColor : '' }} class="custom-control-label"
                                            for={`categorySet${filterIndex}`} dangerouslySetInnerHTML={{ __html: filter.filterName }} />
                                        </div>
                                      )}
                                      <div className='errorMsg text-center'>
                                        {this.state.errors.category}
                                      </div>
                                    </div>
                                  )
                                case "text":
                                  return (
                                    <div className='optin-row'>
                                      <div className='optin-col'>
                                        <FormControl
                                          componentClass='textarea'
                                          style={{ height: 120 }}
                                          placeholder={t('entry_500_char')}
                                          onChange={this.handleTextAreaChange}
                                          name='image_description'
                                          value={this.state.fields.image_description || ''}
                                          maxLength='500'
                                        />
                                      </div>
                                      <div className='charLength' style={{ color: data ? data.primaryColor : '' }}>{this.state.charLength ? this.state.charLength : `${t('character_left')}: 500/500`}</div>
                                      <div className='errorMsg'>
                                        {this.state.errors.image_description}
                                      </div>
                                    </div>
                                  )
                                default:
                                  return (
                                    <div className='optin-row'>
                                      <div className='optin-col'>
                                        <FormControl
                                          type={oo.type}
                                          placeholder={t(oo.placeholder)}
                                          onChange={this.handleChange}
                                          name={oo.name}
                                          value={oo.value || ''}
                                        />
                                      </div>
                                      <div className='errorMsg'>
                                        {oo.error.field}
                                      </div>
                                    </div>
                                  )
                              }
                            })}
                        </div>
                      ) : null}

                      <div className='optin-row'>
                        {submitLoad ? (
                          <div className='optin-col upload-btn-wrapper submit-btn-wrapper'>
                            <input
                              type='submit'
                              className='button submit-btn'
                              value={data.submitCopy}
                              style={{
                                backgroundColor: data ? data.buttonColor : '',
                                color: data ? data.secondaryColor : '',
                              }}
                            />
                          </div>
                        ) : null}
                        {submitSpin ? (
                          <div className='optin-col upload-btn-wrapper'>
                            <i className='fa fa-spinner fa-spin fa-3x' />
                          </div>
                        ) : null}
                        {/*
                        {facebookShare || twitterShare ? (
                          <div className='shares-cont'>
                            {facebookShare ? (
                              <div
                                className='share-btn faceShare'
                                onClick={() =>
                                  this.handleFacebookShare(facebookShare)
                                }
                              >
                                <i
                                  className='fa fa-2x fa-facebook'
                                  aria-hidden='true'
                                />
                                <div class="text-nowrap"><Trans i18nKey="share" /></div>
                              </div>
                            ) : null}
                            {twitterShare ? (
                              <div
                                className='share-btn twitterShare'
                                onClick={() =>
                                  this.handleTwitterShare(twitterShare)
                                }
                              >
                                <i
                                  className='fa fa-2x fa-twitter'
                                  aria-hidden='true'
                                />
                                <div class="text-nowrap"><Trans i18nKey="share" /></div>
                              </div>
                            ) : null}
                            <MarketingButtons />
                          </div>
                        ) : null} */}


                        {this.state.responseError ? (
                          <div className='errMsg'>{this.state.responseError}</div>
                        ) : null}
                        <div className="tester"></div>
                      </div>
                    </div>
                  </form>
                ) : null}

                {successMsg ? (
                  <div>
                    <div className='successMsg text-center mt-5' style={{ color: data ? data.primaryColor : '' }}>
                      {data.thanksCopy && data.thanksCopy != '' ? (<div style={{ color: data ? data.primaryColor : '' }}
                        dangerouslySetInnerHTML={{ __html: data.thanksCopy }}></div>) : successMsg}
                    </div>

                    {data && data.isViralSharingEnabled && data.viralBoosters && data.viralBoosters.length

                      ? <div>
                        <div className="col-sm-12">
                          <div className="v-booster-section">
                            {this.props.competition.vBoosterTotalPoints > 0
                              ? <p class="points-so-far text-center"
                                style={{ color: data ? data.primaryColor : '' }}>
                                YOU'VE GOT {this.props.competition.vBoosterTotalPoints} ENTRIES SO FAR...</p>
                              : null
                            }
                            {data.drawCopy && data.drawCopy != '' ? <div className="v-b-info">
                              <span
                                style={{
                                  color: data.primaryColor ? data.primaryColor : '#FFFFFF'
                                }}
                                dangerouslySetInnerHTML={{ __html: data.drawCopy }}>
                              </span>
                            </div> : ''}
                            {data.viralBoosters.map((vb, vbIndex) =>
                              <div className="v-booster" style={{
                                backgroundColor: vb.buttonColor ? vb.buttonColor : '#808080',
                                color: vb.textColor ? vb.textColor : '#FFFFFF',
                              }} onClick={() => this.triggerVBooster(vb)}
                                key={vbIndex}>
                                {vb.image ? <img src={vb.image.file} /> : ''}
                                <span className="v-b-text">{vb.ctaText}</span>
                                {vb.points && (!this.props.competition.clickedBoosters.length
                                  || !this.props.competition.clickedBoosters.includes(vb.id)
                                )
                                  ? <span class="v-b-points">
                                      + {vb.points} entries
                                    </span>
                                  : null}
                                {this.props.competition && this.props.competition.clickedBoosters.length
                                  && this.props.competition.clickedBoosters.includes(vb.id)
                                  ? <span className="v-b-p-added">
                                    <img src="https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/common-images/icons/tick_green.png" />
                                  </span>
                                  : null}
                              </div>
                            )}
                          </div>

                        </div>
                      </div>

                      : null}

                  </div>
                ) : null}

                {data && data.shareEnabled ?
                  <div className='social-share-multi'>
                    <IoMdArrowDropleft onClick={() => this.handleChangeShare('previous')} style={{ cursor: 'pointer' }} size={50} color="#fff" fill={data.buttonColor} />
                    <div className='social-share-wrapper' ref={this.socialShareRef}>
                      <div className='wrapper' > <FacebookShareButton
                        url={socialShareUrl}
                        quote={socialShareTitle}
                        size={32} round={true} >
                        <FacebookIcon size={32} round={true} />
                      </FacebookShareButton>
                        <TwitterShareButton
                          url={socialShareUrl}
                          title={socialShareTitle}
                        >
                          <TwitterIcon size={32} round={true} />
                        </TwitterShareButton>
                      </div>
                      <div className='wrapper' >
                        <CustomShare className="messenger" variant="facebook-messenger" config={{ url: socialShareUrl }}>
                          <FacebookMessengerIcon size={32} round={true} />
                        </CustomShare>
                        <WhatsappShareButton
                          url={socialShareUrl}
                          title={socialShareTitle}
                        >
                          <WhatsappIcon size={32} round={true} />
                        </WhatsappShareButton>
                      </div>
                      <div className='wrapper' >
                        <CustomShare className="sms" variant="sms" config={{
                          text: socialShareTitle + ' ', url: socialShareUrl,
                        }}><FaSms size={20} style={{ color: '#3B5997', fill: '#ffffff' }} /></CustomShare>
                        <EmailShareButton
                          url={socialShareUrl}
                          subject={socialShareTitle}
                          body={socialShareDescription} >
                          <EmailIcon size={34} round={true} />
                        </EmailShareButton>
                      </div>
                      <div className='wrapper' >
                        {/* <LinkedinShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              summary={socialShareDescription}
                              source={socialShareUrl}
                              >
                              <LinkedinIcon size={32} round={true} />
                              </LinkedinShareButton> */}
                        <RedditShareButton
                          url={socialShareUrl}
                          title={socialShareTitle}
                          description={socialShareDescription} >
                          <RedditIcon size={32} round={true} />
                        </RedditShareButton>
                        <CustomShare className="skype" config={{
                          url: socialShareUrl,
                          text: socialShareTitle
                        }} variant="skype"><FaSkype size={20} style={{ color: '#3B5997', fill: '#ffffff' }} /></CustomShare>
                      </div>
                      <div className='wrapper' >
                        <PinterestShareButton
                          url={socialShareUrl}
                          title={socialShareTitle}
                          description={socialShareDescription}
                          media={socialShareMedia}
                        >
                          <PinterestIcon size={32} round={true} />
                        </PinterestShareButton>
                        <CustomShare className="wordpress" variant="wordpress" config={{
                          url: socialShareUrl,
                          text: socialShareTitle,
                          media: socialShareMedia
                        }}><FaWordpress size={20} style={{ color: '#3B5997', fill: '#ffffff' }} /></CustomShare>
                      </div>
                      <div className='wrapper' >
                        <CustomShare className="flipboard" variant="flipboard" config={{
                          url: socialShareUrl,
                          text: socialShareTitle
                        }}><FaFlipboard size={20} style={{ color: '#3B5997', fill: '#ffffff' }} /></CustomShare>
                        <TumblrShareButton
                          url={socialShareUrl}
                          title={socialShareTitle}
                          caption={socialShareDescription} >
                          <TumblrIcon size={34} round={true} />
                        </TumblrShareButton>
                      </div>
                      <div className='wrapper' >
                        <CustomShare className="buffer" variant="buffer" config={{
                          url: socialShareUrl,
                          text: socialShareTitle,
                          media: socialShareMedia
                        }}><FaBuffer size={18} style={{ color: '#3B5997', fill: '#ffffff' }} /></CustomShare>
                        <PocketShareButton
                          url={socialShareUrl}
                          title={socialShareTitle}
                          description={socialShareDescription} >
                          <PocketIcon size={32} round={true} />
                        </PocketShareButton>
                      </div>
                      {/* <div className='wrapper' >

                            </div> */}
                    </div>
                    <IoMdArrowDropright onClick={() => this.handleChangeShare('next')} style={{ cursor: 'pointer' }} size={50} color="#fff" fill={data.buttonColor} />
                  </div> : null}

                <Popup
                  open={this.state.open}
                  closeOnDocumentClick
                  onClose={this.closeModal}
                  contentStyle={(this.modalCustomStyling(this.state.assetTypeId))}
                  overlayStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
                  className={(this.state.assetTypeId > 0 ? 'assetPopup' : '')}
                >
                  <div className="inner">
                    <a className="close" onClick={this.closeModal}>
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                    {this.renderAssetInPopup(this.state.assetTypeId)}
                  </div>
                </Popup>
              </div>
            </div>
            {/* photowall filters */}
            {(data.photowallConfigs && data.photowallConfigs.enableFilter && data.photowallFilters.length > 0) ? (
              <div className='categoryFilter filterImage'>
                {data.photowallFilters.map((filter) =>
                  <a onClick={(e) => this.customFilter(e, filter.id)}
                    style={this.state.customFilterImageState !== filter.id ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }}
                    className={(this.state.customFilterImageState === filter.id ? 'filterImageSelected ' : '')}>
                    {filter.filterName}
                  </a>
                )}
              </div>
            ) : null}

            {data.photowallConfigs && data.photowallConfigs.enableFilter ?
            <div className='defaultFilter defaultFilterImage filterImage'>
              <a onClick={this.mostRecent} style={(this.state.filterImageState !== 1) ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }} className={(this.state.filterImageState === 1 ? 'filterImageSelected filterMostRecent ' : 'filterMostRecent')}><Trans i18nKey="most_recent" /></a>
              <a onClick={this.mostPopular} style={(this.state.filterImageState !== 2) ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }} className={(this.state.filterImageState === 2 ? 'filterImageSelected filterMostPopular ' : 'filterMostPopular')}><Trans i18nKey="most_popular" /></a>
              <a onClick={this.randomFilter} style={(this.state.filterImageState !== 3) ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }} className={(this.state.filterImageState === 3 ? 'filterImageSelected filterRandom ' : 'filterRandom')}><Trans i18nKey="random" /></a>
            </div>
            : null}
            {imagesList && imagesList.length ?
            <div className='photoGrid'>
              <StackGrid
                columnWidth={300}
                gutterWidth={20}
                gutterHeight={20}
                gridRef={grid => this.grid = grid}
              >
                {imagesList.map((data, index) => {
                  return (
                    <div key={index}>
                      <div className='card' style={{backgroundColor: competition.data.backgroundColor, color: competition.data.primaryColor, borderColor: competition.data.borderColor }}>
                        {/* <div className = 'card-inner' style={{ backgroundColor: competition.data.backgroundColor }}> */}
                        {data.assetTypeId && (data.assetTypeId === 2) ?
                          <LazyLoad onContentVisible={this.updateGrid}>
                            <div onClick={(e) => this.openModal(e, data.id)}
                              style={{
                                backgroundSize: `cover`,
                                backgroundPosition: `center`,
                                height: `162px`
                              }}
                              className={'head play-content-outer'}
                            >
                              <div className='play-content-inner'><i className='fa fa-music fa-5x' /></div>
                            </div>
                          </LazyLoad> : ''}
                        {data.assetTypeId && (data.assetTypeId === 1 || data.assetTypeId === 3) ?
                          <LazyLoad onContentVisible={this.updateGrid}>
                            <div onClick={(e) => this.openModal(e, data.id)}
                              style={{
                                backgroundImage: `url(${this.getImageUrl(data)})`,
                                backgroundSize: `cover`,
                                backgroundRepeat: `no-repeat`,
                                backgroundPosition: `center center`,
                                minHeight: `162px`,
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px'
                              }}
                              className={(data.assetTypeId === 3 ? 'head play-content-outer' : 'head')}
                            >
                              <img src={this.getImageUrl(data)} style={{
                                visibility: `hidden`,
                                height: `auto`,
                                width: '100%'
                              }} />
                              {data.assetTypeId === 3 ?
                                <div className='play-content-inner'><i className='fa fa-play fa-5x' /></div>
                                : ''}
                            </div>
                            {/* <img
                              className='card-img-top'
                              src={
                                data.s3_bucket_url +
                                data.s3_key_prefix +
                                data.image_name
                              }
                              alt='Card image cap'
                            /> */}
                          </LazyLoad> : ''}
                        {data.assetTypeId && (data.assetTypeId === 4) ?
                          <LazyLoad onContentVisible={this.updateGrid}>
                            <div onClick={(e) => this.openModal(e, data.id)}
                              style={{
                                backgroundSize: `cover`,
                                backgroundPosition: `center`,
                                height: `162px`
                              }}
                              className={'head play-content-outer'}
                            >
                              <div className='play-content-inner'><i className='fa fa-file-pdf-o fa-5x' /></div>
                            </div>
                          </LazyLoad> : ''}
                        {data.assetTypeId ?
                          <div className='card-body'>
                            {competition.data.id != 5484 ?
                              <h5 className='card-title'>
                                {data.first_name + ' ' + data.last_name}
                              </h5> :
                              <h5 className='card-title'>
                                {data.first_name}
                              </h5>}
                            <p onClick={(e) => this.openModal(e, data.id)}
                              className='card-text'
                            >{data.image_description}</p>
                            <div className='clearfix'>
                              <i
                                className='fa fa-thumbs-up fa-1x votes'
                                onClick={() =>
                                  this.upVote(data.id, data.vote_count, index)
                                }
                              />
                              <span className='upvote'>{data.vote_count}</span>
                            </div>
                          </div> : ''}
                        {!data.assetTypeId ?
                          <div className='card-body'>
                            <p onClick={(e) => this.openModal(e, data.id)}
                              className='onlyAssetPopupDesc card-text onlyTextContent'
                            >{this.truncateString(data.image_description, 175)}</p>
                            {competition.data.id != 5484 ?
                              <h5 className='card-title'>
                                {data.first_name + ' ' + data.last_name}
                              </h5> :
                              <h5 className='card-title'>
                                {data.first_name}
                              </h5>}
                            <div className='clearfix'>
                              <i
                                className='fa fa-thumbs-up fa-1x votes'
                                onClick={() =>
                                  this.upVote(data.id, data.vote_count, index)
                                }
                              />
                              <span className='upvote'>{data.vote_count}</span>
                            </div>
                          </div> : ''}
                      {/* </div> */}
                    </div>
                      {competition.data.defaultShape === 5 ?
                        <div class="info-bottom" style={{
                          backgroundColor: competition.data.backgroundColor,
                          borderColor: competition.data.borderColor
                        }}>
                          <div class="info-bottom-border" style={{ backgroundColor: competition.data.borderColor }}></div>
                        </div> : ''
                      }
                    </div>
                  );
                })}
              </StackGrid>
            </div>
            : null}
            {data.sponsorsBg && data.sponsorsTop == 0 ?
              (
                <div className='logos-cont sponsors'>
                  {((data.sponsorsLink && data.sponsorsLink != '') ?
                    (
                      <a href={data.sponsorsLink} target="_blank">
                        <img src={data.sponsorsBg.file} className='sp-logo logo-image' />
                      </a>
                    ) : (
                      <img src={data.sponsorsBg.file} className='sp-logo logo-image' />
                    ))}
                </div>
              ) : null}
            {!hasEmbedFooter ? <div>{footerCont}</div> : null}
          </div>
        );

        return <div className={'parent-vote-cont'}>{voteCont}</div>;
      }
      else {
        return (
          <div className={`vote-status`}>
            <div className={'closed'}>
              <Trans i18nKey="now_closed" />!
            </div>
            {!hasEmbedFooter ? <div>{footerCont}</div> : null}
          </div>
        );
      }
    } else {
      return (
        <div className='vote-cont'>
          <div className='loading-rounds' />
        </div>
      );
    }
  }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {
  console.log('state', state);
  const prj = state.default;
  return {
    ...ownProps,
    competition: prj.competition,
    comp: prj.competition.data,
    locale: prj.locale
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Photos));
